import React, { useState, useEffect } from 'react';

const LoadingOverlay = ({ loadingText, onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let interval;
    const duration = 15000; // 15 seconds
    const steps = 100; // 100 steps for smooth animation
    const stepTime = duration / steps;
    
    // 使用setInterval实现匀速增长
    interval = setInterval(() => {
      setProgress(prevProgress => {
        const nextProgress = prevProgress + 1;
        
        if (nextProgress >= 100) {
          clearInterval(interval);
          
          // 当进度条达到100%时，添加淡出效果
          setFadeOut(true);
          
          // 等待淡出动画完成后再触发onComplete
          setTimeout(() => {
            setVisible(false);
            if (onComplete) onComplete();
          }, 300); 
          
          return 100;
        }
        
        return nextProgress;
      });
    }, stepTime);

    return () => {
      clearInterval(interval);
    };
  }, [onComplete]);

  if (!visible) return null;

  // 确保显示英文文本 "Sending Order..." 作为默认文本
  const displayText = loadingText || "Sending Order...";
 
  return (
    <div className={`loading-overlay ${fadeOut ? 'fade-out' : ''}`}>
      <div className="loading-message">
        <div>{displayText}</div>
      </div>
      <div className="progress-container">
        <div 
          className="progress-bar" 
          style={{ width: `${progress}%` }}
        />
      </div>
      <style jsx>{`
        .loading-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(128, 128, 128, 0.85); /* 半透明灰色背景 */
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 0 20px;
          opacity: 1;
          transition: opacity 0.3s ease;
        }
        
        .loading-overlay.fade-out {
          opacity: 0;
        }
        
        .loading-message {
          margin-bottom: 15px;
          color: #ffc107; /* 使用与进度条同样的黄金色 */
          font-size: 18px;
          font-weight: 500;
          text-align: center;
          max-width: 80%;
          line-height: 1.5;
        }
        
        .progress-container {
          width: 80%;
          max-width: 400px;
          height: 10px; /* 稍微加大进度条高度 */
          background-color: rgba(240, 240, 240, 0.3); /* 稍微增加进度条背景的可见度 */
          border-radius: 5px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(255, 255, 255, 0.2); /* 稍微亮一点的阴影 */
        }
        
        .progress-bar {
          height: 100%;
          background-color: #ffc107; /* 适配OrderDetails中的默认颜色 */
          border-radius: 5px;
          transition: width 0.1s linear; /* 线性过渡确保匀速效果 */
        }
        
        @media (max-width: 480px) {
          .progress-container {
            width: 90%;
            height: 8px;
          }
          
          .loading-message {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingOverlay;